"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ projectId }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "作成日時",
                propertyName: "createdAt",
                schema: {
                    schemaType: "datetime",
                },
            },
            {
                title: "翻訳ファイル名",
                propertyName: "segmentName",
                schema: {
                    schemaType: "text",
                },
            },
            {
                title: "削除日時",
                propertyName: "deletedAt",
                schema: {
                    schemaType: "datetime",
                },
            },
        ],
    };
};
